module.exports = __webpack_public_path__ + "img/intro_phone3.bb5499ba.png";